<div class="container mt-4 p-4">
  <div class="row text-center">
    <h1 class="col-12">Hello Team</h1>
  </div>
  <div class="row pt-3 text-center">
    <img class="col-4 m-auto" src="https://media.tenor.com/DyTpg7ZLg7wAAAAC/wavingbear-hi.gif">
  </div>
</div>